<template>
  <div class="Div">
    <div class="backimg">

      <img
        class="img"
        :src="banner.banner_img"
        alt=""
      >
      <div class="Title">
        {{banner.banner_name_cn}}
        <p>{{banner.banner_name_en}}</p>
      </div>
    </div>
    <!-- 顾问团队 -->
    <section class="section1">
      <div class="stitle">
        <p class="p1">{{detail.plateOne.title}}</p>
        <p class="p2">{{detail.plateOne.describe}}</p>
      </div>
      <ul class="ul" v-if="detail.plateOne.list.length>0">
        <li
          class="li"
          v-for="(item,i) of detail.plateOne.list"
          :key="i"
          @click="detailClick(item)"
        >
          <img
            class="avatar"
            :src="item.teacher_img"
            alt=""
          >
          <p class="name">{{item.teacher_name_cn}}</p>
          <p class="office">{{item.position_name_cn}}</p>
        </li>
      </ul>
    </section>
    <!-- 总校长介绍 -->
    <section class="section2">
      <div class="content" v-html="detail.plateTwo.summary_content_cn">
        <!-- <div class="left">
          <div class="text">
            <p class="p1">{{detail.plateTwo.title}}</p>
            <div class="div1">
              {{detail.plateTwo.data.teacher_introduce_cn}}
            </div>
          </div>
        </div>
        <div class="right">
          <img
            :src="detail.plateTwo.data.teacher_img"
            alt=""
          >
        </div> -->
      </div>
    </section>
    <!-- 学校部长介绍 -->
    <!-- <section class="section3" >
      <div class="stitle">
        <p class="p1">{{detail.plateThree.title}}</p>
      
      </div>
      <div class="content" v-html="detail.plateThree.summary_content_cn">
      </div>
    </section> -->
    <!-- 管理团队概述 -->
    <!-- <section class="section4" >
      <div class="stitle">
        <p class="p1">{{detail.plateFour.summary_title_cn}}</p>
       
      </div>
      <div
        class="content"
        v-html="detail.plateFour.summary_content_cn"
      >
      </div>
    </section> -->
  </div>
</template>
<script>
import { Teacher, getBanner } from "../../api/home";
export default {
  name: "ManagementTeam",
  data() {
    return {
      detail: {
        plateOne: { list: [{}] },
        plateTwo: { data: [] },
        plateThree: { list: [] },
        plateFour: { data: [] }
      },
      banner:{},
    };
  },
  methods:{
    detailClick(item){
      var laber=[0,31,18]
      var laPath=['/','ManagementTeam']
      var routeData=this.$router.resolve({
        path: "/TeacherDetail",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          id: item.teacher_id,
          type:1,
        }
      });
       window.open(routeData.href, "_blank");
    },
  },
  created() {
    Teacher({}).then(res => {
      // console.log(res.data)
      this.detail = res.data;
    });
    getBanner({ address: 31 }).then(res => {
      this.banner=res.data
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  //   min-height: 100%;
  padding: 0.1px 0;
  //   background: #f5f5f5;
  .backimg {
    position: relative;
    width: 100%;
    height: px2Rem(400px);
    &::after {
      display: block;
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      //   z-index: 1;
    }
    .img {
      //   position: absolute;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.Title {
  position: absolute;
  width: 100%;
  top: px2Rem(129px);
  font-size: px2Rem(80px);
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  z-index: 1;
  text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
  p {
    margin-top: px2Rem(20px);
    font-size: px2Rem(40px);
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
  }
}
.stitle {
  width: px2Rem(1300px);
  margin: auto;
  margin-bottom: px2Rem(40px);
  text-align: center;
  .p1 {
    font-size: px2Rem(40px);
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  .p2 {
    padding-top: px2Rem(10px);
    font-size: px2Rem(24px);
    font-weight: 400;
    color: #606060;
    line-height: px2Rem(40px);
  }
}
.section1 {
  width: px2Rem(1300px);
  margin: px2Rem(60px) auto px2Rem(30px);

  .ul {
    font-size: 0;
    .li {
      position: relative;
      display: inline-block;
      width: px2Rem(268px);
      //   height: px2Rem(400px);
      padding: 0.1px;
      margin-bottom: px2Rem(30px);
      margin-right: px2Rem(70px);
      bottom: 0;
      border: 1px solid rgba(205, 205, 205, 1);
      text-align: center;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      cursor: pointer;
      vertical-align: top;
      transition: 0.5s;
      &:hover {
        bottom: px2Rem(10px);
        box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.16);
      }
      &:nth-of-type(4n) {
        margin-right: 0;
      }
      .avatar {
        display: block;
        width: px2Rem(250px);
        height: px2Rem(296px);
        margin: px2Rem(10px) auto;
      }
      .name {
        margin: 0 px2Rem(15px);
        margin-top: px2Rem(20px);
        font-size: px2Rem(24px);
      }
      .office {
        margin: px2Rem(5px) px2Rem(15px) px2Rem(25px);
        font-size: px2Rem(18px);
      }
    }
  }
}
.section2 {
  padding: 0.1px;
  // background: #f5f5f5;
  padding-bottom: px2Rem(60px);
  .content {
    // width: px2Rem(1300px);
    margin: px2Rem(60px) auto 0;
    font-size: 0;
    .left {
      display: inline-block;
      position: relative;
      width: px2Rem(610px);
      height: px2Rem(420px);
      margin-right: px2Rem(48px);
      vertical-align: top;
      .text {
        // position: absolute;
        // top: 50%;
        // transform: translate(0, -50%);
      }
      .p1 {
        font-size: px2Rem(40px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .div1 {
        margin-top: px2Rem(40px);
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #787878;
        line-height: px2Rem(40px);
      }
    }
    .right {
      display: inline-block;
      width: px2Rem(640px);
      height: px2Rem(420px);
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
.section3 {
  padding: 0.1px;
  padding-bottom: px2Rem(40px);
  margin-top: px2Rem(60px);
  .content {
    width: px2Rem(1300px);
    // padding-bottom: px2Rem(40px);
    margin: px2Rem(0px) auto 0;
    font-size: 0;
    .div {
      height: px2Rem(434px);
      margin-bottom: px2Rem(20px);
      font-size: 0;
    }
    .img {
      display: inline-block;
      width: px2Rem(310px);
      height: 100%;
      vertical-align: top;
    }
    .pioneer {
      position: relative;
      display: inline-block;
      width: px2Rem(910px);
      height: 100%;
      margin: 0 0 0 px2Rem(78px);
      //   background: rgba(255, 255, 255, 1);
      .title {
        margin: px2Rem(0px) 0 px2Rem(30px);
        font-size: px2Rem(30px);
        font-weight: 400;
        color: #333;
        .office {
          font-size: px2Rem(24px);
        }
      }
      .summary {
        // height: px2Rem(160px);
        line-height: px2Rem(40px);
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #787878;
      }
      .pionC {
        position: absolute;
        // width: 100%;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
    .pioneer1 {
      margin: 0 px2Rem(78px) 0 0;
    }
  }
}
.section4 {
  padding: 0.1px;
  padding-top: px2Rem(60px);
  padding-bottom: px2Rem(20px);
  // background: #f5f5f5;
  .content {
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(60px) auto 0;
    font-size: 0;
    .div {
      height: px2Rem(420px);
      margin-bottom: px2Rem(20px);
      font-size: 0;
    }
    .img {
      display: inline-block;
      width: px2Rem(640px);
      height: 100%;
      vertical-align: top;
    }
    .pioneer {
      position: relative;
      display: inline-block;
      width: px2Rem(617px);
      height: 100%;
      margin: 0 0 0 px2Rem(43px);
      .summary {
        // height: px2Rem(160px);
        line-height: px2Rem(40px);
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #787878;
      }
      .pionC {
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
    .pioneer1 {
      margin: 0 px2Rem(43px) 0 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/ManagementTeam/Index.vue